import React from 'react';
import PropTypes from 'prop-types';
import { identity, prop } from 'ramda';
import { Container } from './accordionCheckbox.styles';
import { AccordionCheckboxOption } from './accordionCheckboxOption';

export const AccordionCheckbox = ({
  subOptionsMarkedCountMessage,
  allSubOptionsMarkedMessage,
  options,
  inputsState,
  labelFieldName,
  checkedFieldName,
  subOptionsFieldName,
  onOptionClick,
  onSubOptionClick,
}) => {
  return (
    <Container>
      {options.map(option => (
        <AccordionCheckboxOption
          key={option[checkedFieldName]}
          subOptionsMarkedCountMessage={subOptionsMarkedCountMessage}
          allSubOptionsMarkedMessage={allSubOptionsMarkedMessage}
          labelFieldName={labelFieldName}
          checkedFieldName={checkedFieldName}
          subOptionsFieldName={subOptionsFieldName}
          onOptionClick={onOptionClick}
          onSubOptionClick={onSubOptionClick}
          option={option}
          inputsState={prop([option[checkedFieldName]], inputsState)}
        />
      ))}
    </Container>
  );
};

AccordionCheckbox.defaultProps = {
  checkedFieldName: 'id',
  labelFieldName: 'name',
  inputsState: {},
  onSubOptionClick: identity,
  options: [],
};

AccordionCheckbox.propTypes = {
  subOptionsMarkedCountMessage: PropTypes.object.isRequired,
  allSubOptionsMarkedMessage: PropTypes.object.isRequired,
  checkedFieldName: PropTypes.string,
  labelFieldName: PropTypes.string,
  inputsState: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.object),
  subOptionsFieldName: PropTypes.string,
  onOptionClick: PropTypes.func.isRequired,
  onSubOptionClick: PropTypes.func,
};
